<template>
    <q-dialog
        v-model="isOpen"
        content-class="upload-document"
        @input="toggleDialog"
    >
        <q-card>
            <q-card-section>
                <div class="dialog-title text-capitalize q-my-lg">
                    <h5>{{ $t('actions.upload_proof_of_payment') }}</h5>
                </div>
                <div class="form-warp">
                    <q-form>
                        <q-file
                            v-model="document"
                            class="q-mb-lg"
                            bg-color="white"
                            :label="$t('actions.select_file')"
                            dense
                            outlined
                            clearable
                        >
                            <template v-slot:prepend>
                                <q-icon name="attachment" />
                            </template>
                        </q-file>
                    </q-form>
                </div>
            </q-card-section>
            <q-card-actions align="right">
                <q-btn
                    flat
                    :label="$t('actions.cancel')"
                    @click="toggleDialog"
                />
                <q-btn
                    flat
                    :label="$t('actions.upload')"
                    color="secondary"
                    :disable="!document"
                    @click="saveDocument"
                />
            </q-card-actions>
            <q-inner-loading :showing="isSavingDocument">
                <q-spinner-gears size="50px" color="primary" />
            </q-inner-loading>
        </q-card>
    </q-dialog>
</template>

<script>
import base64 from '@/local-shared/mixins/base64'
import ordersService from '@/services/modules/orders'
import notify from '@/local-shared/mixins/notify'
import _ from 'lodash'

const loadingKeys = {
    loadingProofFile: 'loading-proof-file',
    savingDocument: 'saving-document',
}

export default {
    name: 'UploadDocument',

    mixins: [base64, notify],

    props: {
        show: {
            type: Boolean,
            default: false,
        },

        documentType: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            isOpen: false,
            document: null,
        }
    },

    computed: {
        isSavingDocument() {
            return !!this.loadings.filter(
                (loading) => loading.key === loadingKeys.savingDocument
            ).length
        },
    },

    watch: {
        show(value) {
            this.isOpen = value
        },
    },

    created() {
        this.loadingRemove(loadingKeys.savingDocument)
    },

    methods: {
        toggleDialog() {
            this.$emit('toggle-dialog', !this.isOpen)
        },

        async saveDocument() {
            this.loadingAdd(loadingKeys.savingDocument)

            let parameters = {
                data: {
                    order_id: this.$route.params.orderId,
                    documents: [],
                },
            }

            if (!this?.documentType.length) {
                this.$q.notify({
                    type: 'negative',
                    message: this.$t('notify.document_cannot_be_uploaded'),
                })
            } else {
                if (this.document != null) {
                    let filedata = await this.getBase64FromFile(this.document)
                    parameters.data.documents.push({
                        content: _.split(filedata, 'base64,')[1],
                        content_type: _.split(filedata, 'base64,')[0],
                        name: this.document.name,
                        public: true,
                        document_type_id: this.documentType[0].id,
                    })
                }

                var response = await ordersService.addDocuments(parameters)

                if (response.status === 200 && response.data.data[0].id) {
                    this.$q.notify({
                        type: 'positive',
                        message: this.$t('notify.document_uploaded'),
                    })
                    this.$emit('fetch-order')
                    this.toggleDialog()
                } else {
                    this.notifyError(response)
                }
            }

            this.loadingRemove(loadingKeys.savingDocument)
        },
    },
}
</script>
